module.exports = {"420607001":"张湾街道","420607002":"刘集街道","420607003":"肖湾街道","420607004":"六两河街道","420607100":"龙王镇","420607101":"石桥镇","420607102":"黄集镇","420607103":"伙牌镇","420607104":"古驿镇","420607105":"朱集镇","420607106":"程河镇","420607107":"双沟镇","420607108":"张家集镇","420607109":"黄龙镇","420607110":"峪山镇","420607111":"东津镇","420607402":"鹿门风景名胜区","420607500":"襄北农场","420607570":"深圳工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420607.json
// module id = 1863
// module chunks = 0